import { Component, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from "ngx-bootstrap";
import swal from "bootstrap-sweetalert";
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { OnboardingComponent } from './client/components/main/onboarding/onboarding.component';
import { filter, pairwise } from 'rxjs/operators';
import { ApplicationSettingsService } from './services/applicationSettings.service';

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>'
})
export class AppComponent {
    public onboardingModalRef: BsModalRef;

    constructor(
        private router: Router,
        private applicationSettingsService: ApplicationSettingsService,
        private modalService: BsModalService) { }


        ngOnInit() {
            this.router.events.pipe(
                filter((event) => event instanceof NavigationEnd),
                pairwise()
            ).subscribe(([previous, current]: [NavigationEnd, NavigationEnd]) => {
                if (previous.url == '/account/signin') {
                    this.applicationSettingsService.applicationSettings.subscribe(applicationSettings => {
                        if (applicationSettings.banner && applicationSettings.banner.content && applicationSettings.banner.title)
                        {
                            this.onboardingModalRef = this.modalService.show(OnboardingComponent, { class: 'modal-md modal-dialog-centered', backdrop: 'static' });
                            this.onboardingModalRef.content.title = applicationSettings.banner.title;
                            this.onboardingModalRef.content.content = applicationSettings.banner.content
                        }
                    }, _ => {
                        swal({
                            title: 'Ошибка',
                            text: 'Не удалось получить настройки приложения',
                            type: 'error',
                            confirmButtonText: 'Ок'
                        });
                    });
                }
            });
        }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/app.component.ts